import _ from 'lodash';
import moment from 'moment';
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { STATUS, STATUS_TEXT } from '../constants';
import { countries } from '../../../../tester/pages/profile-summary/constants';

import {
  Link,
  Status,
  Table,
  Text,
  Email,
} from './styles';

const formatStatus = (status) => {
  switch (status) {
    case STATUS.SUBMITTED:
      return STATUS_TEXT.SUBMITTED;
    case STATUS.NOT_SUBMITTED:
      return STATUS_TEXT.NOT_SUBMITTED;
    case STATUS.REJECTED:
      return STATUS_TEXT.REJECTED;
    case STATUS.BLOCKED:
      return STATUS_TEXT.BLOCKED;
    default:
      return STATUS_TEXT.APPROVED;
  }
};

const CustomTable = (props) => {
  const {
    onOpenVideo,
    practiceTests,
    onClick,
  } = props;

  const hasPracticeTests = !_.isEmpty(practiceTests);

  const practiceTestsSorted = useMemo(() => (
    hasPracticeTests
      ? _.sortBy(practiceTests, ({ practiceTestStatus }) => practiceTestStatus !== STATUS.SUBMITTED)
      : practiceTests
  ), [hasPracticeTests, practiceTests]);

  const getCountry = (x) => {
    const country = countries.find((c) => c.key === x);
    return country ? country.text : 'N/A';
  };

  return (
    <Table basic="very">
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>
            <Text.Bold>Tester name</Text.Bold>
          </Table.HeaderCell>
          <Table.HeaderCell>
            <Text.Bold>First name</Text.Bold>
          </Table.HeaderCell>
          <Table.HeaderCell>
            <Text.Bold>Last name</Text.Bold>
          </Table.HeaderCell>
          <Table.HeaderCell>
            <Email>
              <Text.Bold>Email</Text.Bold>
            </Email>
          </Table.HeaderCell>
          <Table.HeaderCell>
            <Text.Bold>Country</Text.Bold>
          </Table.HeaderCell>
          <Table.HeaderCell>
            <Text.Bold>Log In</Text.Bold>
          </Table.HeaderCell>
          <Table.HeaderCell>
            <Text.Bold>Date Submitted</Text.Bold>
          </Table.HeaderCell>
          <Table.HeaderCell>
            <Text.Bold>Status</Text.Bold>
          </Table.HeaderCell>
        </Table.Row>
      </Table.Header>

      <Table.Body>
        {practiceTestsSorted.map((practiceTest) => {
          const {
            id,
            practiceTestStatus: status,
            completedAt,
            tester: {
              id: testerId,
              user: {
                email,
                profile,
                facebookId,
                linkedinId,
                googleId,
              },
              project,
            },
          } = practiceTest;

          const { firstName, lastName, country } = profile;
          const testerName = `${firstName} ${lastName}`;

          let logIn = 'None';
          if (facebookId) {
            logIn = 'Facebook';
          } else if (linkedinId) {
            logIn = 'LinkedIn';
          } else if (googleId) {
            logIn = 'Google';
          }

          return (
            <Table.Row key={id}>
              <Table.Cell>
                {status !== STATUS.NOT_SUBMITTED ? (
                  <Link onClick={() => onOpenVideo(project.id, testerId)}>
                    {testerName}
                  </Link>
                ) : (
                  <Text>{testerName}</Text>
                )}
              </Table.Cell>

              <Table.Cell>
                <Text>{firstName}</Text>
              </Table.Cell>

              <Table.Cell>
                <Text>{lastName}</Text>
              </Table.Cell>

              <Table.Cell>
                <Text>{email}</Text>
              </Table.Cell>

              <Table.Cell>
                <Text>{getCountry(country)}</Text>
              </Table.Cell>
              <Table.Cell>
                <Text>{logIn}</Text>
              </Table.Cell>

              <Table.Cell>
                <Text>{completedAt ? moment(completedAt).format('L') : 'N/A'}</Text>
              </Table.Cell>

              <Table.Cell>
                <Status>
                  <Text>{formatStatus(status)}</Text>
                  <Link onClick={() => onClick(id)}>Change</Link>
                </Status>
              </Table.Cell>
            </Table.Row>
          );
        })}
      </Table.Body>
    </Table>
  );
};

CustomTable.propTypes = {
  onClick: PropTypes.func.isRequired,
  practiceTests: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      practiceTestStatus: PropTypes.string,
      status: PropTypes.string.isRequired,
      tester: PropTypes.shape({
        id: PropTypes.string.isRequired,
        user: PropTypes.shape({
          id: PropTypes.string.isRequired,
          email: PropTypes.string.isRequired,
          profile: PropTypes.shape({
            id: PropTypes.string.isRequired,
            firstName: PropTypes.string,
            lastName: PropTypes.string,
            country: PropTypes.string,
          }).isRequired,
        }).isRequired,
      }).isRequired,
    }).isRequired,
  ).isRequired,
  onOpenVideo: PropTypes.func.isRequired,
};

export default CustomTable;
